export { default } from "./Hamburger";
